import { ComponentProps } from 'react';

export function makePreloadedComponent<T extends (...args: any) => JSX.Element>(
  Component: T,
  props: ComponentProps<T>
) {
  return () => <Component {...props} />;
}
